<template>
  <div class="u-radius-g u-padding-xsmall">
    <component
      :is="drawer ? 'router-link' : 'div'"
      :to="`/projects/${project.id}`"
    >
      <h4>
        <span class="u-color-danger">{{ project.model }}</span>
      </h4>
    </component>
    <div
      class="u-display-flex u-align-items-center u-justify-content-space-between u-width-100%"
    >
      <p class="u-color-muted">
        <small
          >{{ $t("common.createdDate") }}
          {{ $date.format(project.createdDate) }}</small
        >
      </p>
      <div>
        <Button
          variant="light-danger"
          class="u-margin-right-xsmall"
          @click="pdfIsCreating = true"
        >
          <i class="icofont-print"></i> {{ $t("common.print") }}
        </Button>

        <Button
          v-if="project.isPermission"
          @click="TO_THE_ID('changed-logs')"
          class="u-margin-right-xsmall"
          variant="light-primary"
          >{{ $t("common.records") }}</Button
        >
        <component
          :is="
            project.isPermission && !project.isLocked ? 'router-link' : 'span'
          "
          :to="`/projects/${project.id}/edit`"
        >
          <Button
            :disabled="!project.isPermission || project.isLocked"
            size="sm"
            variant="light-warning"
          >
            <i
              :class="`icofont-${
                project.isPermission && !project.isLocked
                  ? 'edit-alt'
                  : 'ui-lock'
              }`"
            ></i>
            {{ $t("common.edit") }}
          </Button>
        </component>
      </div>
    </div>
    <div class="u-border-top u-margin-top-xsmall row u-padding-0">
      <div
        class="es-xs-12 es-sm-4 es-md-4 es-lg-4 u-border-right u-padding-left-xsmall"
      >
        <p class="u-color-muted">
          <small>
            <i class="icofont-user"></i>
            {{ $t("project.userInfo") }}</small
          >
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ project.userInfo.fullname }}
        </h5>
      </div>
      <div
        class="es-xs-12 es-sm-4 es-lg-4 u-border-right u-padding-left-xsmall"
      >
        <p class="u-color-muted">
          <small> {{ $t("project.compressor") }}</small>
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          <span> {{ project.compressorBrandInfo.title }} </span>
          <div>
            <small>
              {{ project.compressorBrandRefrigerantInfo.title }} -
              {{ project.compressorRefrigerantModelInfo.title }}
            </small>
          </div>
        </h5>
      </div>
      <div class="es-xs-12 es-sm-4 es-lg-4 u-padding-left-xsmall">
        <p class="u-color-muted">
          <small>
            <i class="icofont-calendar"></i>
            {{ $t("project.updatedAt") }}</small
          >
        </p>
        <h5 class="u-margin-top-xsmall u-color-primary">
          {{ $date.format(project.updatedDate || new Date()) }}
        </h5>
      </div>
    </div>
    <ProjectInfoPdf
      v-if="pdfIsCreating"
      :project="project"
      @pdf-created-link="pdfCreatedLink"
    ></ProjectInfoPdf>
  </div>
</template>

<script>
import Button from "../Base/Button.vue";
import ProjectInfoPdf from "../FileManager/Pdfs/ProjectInfo.vue";
export default {
  components: {
    Button,
    ProjectInfoPdf,
  },
  props: {
    project: {
      default: {},
    },
    drawer: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      pdfIsCreating: false,
    };
  },
  methods: {
    TO_THE_ID(id) {
      this.$router.push({
        path: `/projects/${this.project.id}`,
        query: { tab: "changedLogs" },
      });
      setTimeout(() => {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      }, 250);
    },
    pdfCreatedLink(url) {
      this.pdfIsCreating = false;
      window.open(url, "_blank");
    },
  },
};
</script>

<style></style>
